import { useEffect } from 'react';

const GoogleAdsMaterial2Page = () => {
  useEffect(() => {
    if (window.googletag && window.googletag.cmd) {
      window.googletag.cmd.push(function () {
        window.googletag.display('div-gpt-ad-1731914486640-0');
      });
    }
  }, []);

  return (
    <div
      id="div-gpt-ad-1731914486640-0"
      style={{
        minWidth: '300px',
        minHeight: '90px',
      }}
    ></div>
  );
};

export default GoogleAdsMaterial2Page;
